import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCocktail: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCocktail"><Path d="M0.585938 3L11.0002 13.4142V20H7.00015V22H17.0002V20H13.0002V13.4142L23.4144 3H0.585938Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCocktail;
